// extracted by mini-css-extract-plugin
export default {"title":"_6bb389a19f","inner_title":"dac11af942","charge_btn":"bd0e566d3f"};